import { useEffect } from 'react';
import * as icons from 'react-bootstrap-icons';
import moment from "moment-jalaali";
import DatePickerComponent from 'Utils/Helpers/DatePickerComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import AppMenu from './components/AppMenu';
import { changePage, setDate } from '../../../Redux/slices/globalSlice';
import { HandleVibrate } from 'Utils/Helpers/HandleApiData';

export default function UpMenu({ user_name, clinic_name }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { page, dateSearch, current } = useSelector((state) => ({
        page: state.setting.page,
        dateSearch: state.setting.dateSearch,
        current: state.staff.current,
    }));
    
    const onChangeDate = (value) => {
        if(value.locale("fa").format("jYYYY/jMM/jDD") !== dateSearch.date) {
            const params = {
                date: value.locale("fa").format("jYYYY/jMM/jDD"),
                dow: value.day()
            };
            dispatch(setDate(params));
        }
    }

    const perDay = () => {
        const value = moment(dateSearch.date, 'jYYYY/jMM/jDD').add(-1, 'days');
        const params = {
            date: value.locale("fa").format("jYYYY/jMM/jDD"),
            dow: value.day()
        };
        dispatch(setDate(params));
    }

    const nextDay = () => {
        const value = moment(dateSearch.date, 'jYYYY/jMM/jDD').add(1, 'days');
        const params = {
            date: value.locale("fa").format("jYYYY/jMM/jDD"),
            dow: value.day()
        };
        dispatch(setDate(params));
    }
    const onMouseUp = (e) => {
        HandleVibrate();
    }

    useEffect(() => {
        if(current && current.length !== 0) {
            if(!current[2][0] && window.location.pathname.includes("/dashboard/patients")) {
                navigate("/dashboard");
                dispatch(changePage(0));
            } else if(!current[3][0] && window.location.pathname.includes("/dashboard/users")) {
                navigate("/dashboard");
                dispatch(changePage(0));
            } else if(!current[4][0] && window.location.pathname.includes("/dashboard/setting")) {
                navigate("/dashboard");
                dispatch(changePage(0));
            } else if(window.location.pathname.includes("/dashboard/users")) {
                dispatch(changePage(1));
            } else if(window.location.pathname.includes("/dashboard/patients")) {
                dispatch(changePage(2));
            } else if(window.location.pathname.includes("/dashboard/setting")) {
                dispatch(changePage(4));
            } else {
                dispatch(changePage(0));
            }
        }
    },[current, page, window.location.pathname])

    function DateShow() {
        return (
            <>
                {
                    dateSearch.date !== ''
                    ? <div className='appointment-date'>
                        <div className='next-perv-day' onClick={perDay} onMouseUp={onMouseUp}>
                            <icons.CaretRightFill/>
                        </div>
                        <DatePickerComponent
                            value={moment(dateSearch.date, 'jYYYY/jMM/jDD')}
                            className={'home-date-picker-popup'} 
                            onChange={onChangeDate}
                        />
                        <div className='next-perv-day' onClick={nextDay} onMouseUp={onMouseUp}>
                            <icons.CaretLeftFill/>
                        </div>
                    </div>
                    : <small>{"لطفا کمی صبر کنید"}</small>
                }
            </>
        )
    }

    return (
        <>
            {
                current &&
                <div className='head'>
                    <div className='backstyle'></div>
                    <div className='head-inner'>
                        <AppMenu user_name={user_name} clinic_name={clinic_name}/>
                        <div className='menu-date'>
                            {
                                {
                                    0: current[0][0] ? <DateShow /> : 'داشبورد',
                                    1: <p>لیست کاربران</p>,
                                    2: <p>لیست بیماران</p>,
                                    4: <p>تنظیمات سیستم</p>,
                                }[page]
                            }
                        </div>
                    </div>
                </div>

            }
        </>
    );
}